export function suffix(fileName) {
    let fileInfo = fileName.split(".")
    return fileInfo[fileInfo.length - 1]
}